export const strokeCapSquareIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M3 3v14h17v-2H5V5h15V3zm5 5v4h4v-1h8V9h-8V8z"/></svg>`,
  name: 'stroke-cap-square',
};
